import React from "react";
import HubspotForm from "react-hubspot-form";
import "../../../styles/hubspot-forms/hubspot-forms.css";

export default function HubspotNewsletterSignUpForm() {
  return (
		<div
			id='hubspot-email-newsletter-sign-up'
			className='newsletter-form w-11/12 mx-auto lg:w-full pb-4'
		>
			<HubspotForm
				region='eu1'
				portalId='25525850'
				formId='82cfbbdf-7779-4d7e-959c-984d686bda26'
				onSubmit={() => console.log('Submit!')}
				onReady={(form) => console.log('Form ready!')}
				loading={
					<div>
						<img
							className='animate-spin h-12 w-12 mx-auto '
							src='/images/icons/spinner.svg'
							alt='loading..'
						/>
						<p className='text-center text-white font-semibold text-base'>Loading...</p>
					</div>
				}
			/>
		</div>
  );
}
